export default __webpack_public_path__ + "static/media/waves-phoneL.e9ee59d0.png";